import React from 'react';

const Header = () => (
  <>
    <div className="header">
      <h1>Financial Stock and Coins Data</h1>
    </div>
  </>
);

export default Header;
